export const isBrightcoveUrl = (videoUrl: string) => {
	try {
		const url = new URL(videoUrl);
		return (
			url.protocol === "https:" &&
			url.hostname === "players.brightcove.net" &&
			url.username === "" &&
			url.password === ""
		);
	} catch {
		return false;
	}
};

// React Native's URL is a regex stub, not WHATWG: it neither throws on garbage
// nor lowercases the scheme, so the string guard and toLowerCase do the work there.
export const isHttpUrl = (value: unknown): value is string => {
	if (typeof value !== "string") {
		return false;
	}

	try {
		const protocol = new URL(value).protocol.toLowerCase();
		return protocol === "http:" || protocol === "https:";
	} catch {
		return false;
	}
};

export const isSvgUrl = (url: string) => {
	const [path] = url.toLowerCase().split("?");
	return Boolean(path?.endsWith(".svg"));
};

export type UrlSearchParams = Record<string, string | string[] | undefined>;

export const buildUrlWithSearchParams = (
	baseUrl: string,
	path: string,
	params: UrlSearchParams = {},
) => {
	const query = new URLSearchParams();

	for (const [key, value] of Object.entries(params)) {
		const values = Array.isArray(value) ? value : [value];

		for (const item of values) {
			if (item !== undefined) {
				query.append(key, item);
			}
		}
	}

	const normalizedUrl = `${baseUrl.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
	const queryString = query.toString();

	return `${normalizedUrl}${queryString ? `?${queryString}` : ""}`;
};
